@if (block() && block().sections) {
  <section class="footer-nav">
    <ul
      class="footer-nav__sections grid"
      [ngClass]="block().gridTemplateClasses"
    >
      <!-- Section -->
      @for (section of block().sections; track section) {
        <li class="footer-nav__section" [ngClass]="section.gridItemClasses">
          <!-- Group -->
          @for (item of section.items; track item) {
            <ul class="footer-nav__groups">
              <li class="footer-nav__group footer-nav-group">
                @if (item?.page) {
                  <h4 class="footer-nav-group__title">
                    <a
                      [routerLink]="['/' + item.page.pretty_url] | localize"
                      [externalLink]="item.page.external_url"
                    >
                      {{ item.page.title }}
                    </a>
                  </h4>
                }
                <!-- Links -->
                @if (item?.children) {
                  <ul class="footer-nav-group__item footer-nav-links">
                    @for (child of item.children; track child) {
                      <li class="footer-nav-links__item">
                        @if (child?.page) {
                          <a
                            [routerLink]="
                              ['/' + child.page.pretty_url] | localize
                            "
                            [externalLink]="child.page.external_url"
                            class="footer-nav-links__link"
                            [title]="child.page.short_content || ''"
                          >
                            {{ child.page.title }}
                          </a>
                        }
                      </li>
                    }
                  </ul>
                }
              </li>
            </ul>
          }
        </li>
      }
    </ul>
  </section>
}
